export const getSelectedAssetData = (assignedAssets, assetId) => {
  const selectedAsset = assignedAssets.find(asset => asset.id === assetId);
  const selectedAssetData = {
    id: selectedAsset.id,
    assetId: selectedAsset.assetId,
    name: selectedAsset.name,
  };
  return selectedAssetData;
};
